<svg
  width="32"
  height="32"
  viewBox="0 0 32 32"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <style>
    @media (prefers-color-scheme: dark) { path { fill: white; } }
  </style>
  <path
    d="M20.6746 20.9588V4.02656H13.4443V20.9588H20.6746ZM19.4213 31.36H0.959961V29.5217H3.08085V2.47847H0.959961V0.640115H17.9271C21.9962 0.640115 26.3716 0.568948 29.1581 4.22007C31.1708 6.85722 31.038 9.89109 31.038 12.4927C31.038 15.2151 31.1767 18.2396 29.1099 20.9104C26.2806 24.5667 21.9922 24.442 17.7825 24.442H13.4443V29.5217H19.4213V31.36Z"
    fill="#37512A"
  />
</svg>
